import { isDebug } from '@/libs/version'

export default (modules) => {
  const middlewares = reduceMiddlewares(modules)

  return (store) => (
    store.subscribe((mutation, state) => {
      if (isDebug()) console.log(mutation.type, mutation.payload)
      const hooks = Array.isArray(middlewares[mutation.type]) ? middlewares[mutation.type] : []

      for (const hook of hooks) {
        hook.exec(store, mutation, state)
      }
    })
  )
}

const reduceMiddlewares = (modules) => (
  Object.keys(modules).reduce((hooks, moduleName) => {
    const { middlewares } = modules[moduleName]
    const hookRefs = middlewares && typeof middlewares === 'object' ? Object.keys(middlewares) : []

    for (const hookRef of hookRefs) {
      if (!hooks[hookRef]) hooks[hookRef] = []
      hooks[hookRef].push({ moduleName, hookRef, exec: middlewares[hookRef] })
    }

    return hooks
  }, {})
)
